"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceType = void 0;
var DeviceType;
(function (DeviceType) {
    DeviceType["MEGAPACK_XL"] = "MegapackXL";
    DeviceType["MEGAPACK_2"] = "Megapack2";
    DeviceType["MEGAPACK"] = "Megapack";
    DeviceType["POWERPACK"] = "PowerPack";
    DeviceType["TRANSFORMER"] = "Transformer";
})(DeviceType || (exports.DeviceType = DeviceType = {}));
